import { render, staticRenderFns } from "./ModalUpsertStakeholder.vue?vue&type=template&id=2c1bcb26"
import script from "./ModalUpsertStakeholder.vue?vue&type=script&lang=js"
export * from "./ModalUpsertStakeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports